export const getNumber = (value?: string | null): number => (isNumeric(value) ? Number(value) : 0);

/**
 * @param {string | null} value - String to check if is numeric
 * @returns {boolean} - Boolean response
 */
export const isNumeric = (value?: string | null): boolean => !isNaN(Number(value));

export const numberFormat = (value: number, locale: string = 'it-IT', options?: object): string =>
  new Intl.NumberFormat(locale, options).format(value);

type NumericString = null | undefined | number | string;
export const compareNumberAndNumericString = (a: NumericString, b: NumericString): boolean => {
  if (a === null || a === undefined || b === null || b === undefined) {
    return false;
  }

  return Number(a) === Number(b);
};

/**
 * @param {any} number - Value which type is checked to be Number
 * @returns {boolean} - Boolean response
 */
export const isValidNumber = (number: any): boolean => {
  return typeof number === 'number';
};
